import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ErrorPageContainer, ErrorCode, ErrorMessage, ErrorActionButton } from '../style';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <ErrorPageContainer>
            <ErrorCode>404</ErrorCode>
            <ErrorMessage>The page you are looking for does not exist.</ErrorMessage>
            <ErrorActionButton>
                <Button type="primary" size="large" onClick={() => navigate('/')}>
                    Go Home
                </Button>
            </ErrorActionButton>
        </ErrorPageContainer>
    );
};

export default NotFound;
